import { Screen } from '~/screens/push-notifications';

export const PushNotificationsIndex: React.FC = () => <Screen />;
